import AppColors from 'theme/AppColors';

const StyledComponentsTheme = {
  color: AppColors,
  layout: {
    maxWidth: 1140,
  },
  breakpoint: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export default StyledComponentsTheme;
